import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { axiosInstance } from "../../config/api";

const fmt = (iso) => new Date(iso).toLocaleString("ms-MY", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function MaintenanceBanner({ user }) {
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState({});

  useEffect(() => {
    if (!user) return undefined;
    const load = () => axiosInstance.get("/system/maintenance/active").then((r) => setItems(r.data.items || [])).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const now = Date.now();
  const show = items.filter((m) => !hidden[m.id] && new Date(m.end_at).getTime() > now);
  if (!show.length) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[60] flex flex-col gap-1 p-2 pointer-events-none" data-testid="maintenance-banner">
      {show.map((m) => (
        <div key={m.id} className="pointer-events-auto mx-auto w-full max-w-3xl flex items-start gap-3 rounded-2xl border border-amber-300 bg-amber-50/95 backdrop-blur px-4 py-3 shadow-lg" data-testid={`maintenance-banner-${m.id}`}>
          <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="flex-1 text-sm text-amber-900">
            <div className="font-bold">{m.phase === "sedang" ? "Penyelenggaraan sedang berlangsung" : "Makluman penyelenggaraan sistem"}</div>
            <div>{m.message}</div>
            <div className="text-xs text-amber-700 mt-0.5">{fmt(m.start_at)} - {fmt(m.end_at)}</div>
          </div>
          <button type="button" onClick={() => setHidden((h) => ({ ...h, [m.id]: true }))} className="text-amber-700 hover:text-amber-900" data-testid={`maintenance-banner-close-${m.id}`} aria-label="Tutup">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
